import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';


@Injectable({
  providedIn: 'root'
})
export class AssignedGrievanceViewReplyService {

  constructor(public httpClient: HttpClient) { }




  //load grievance history by id
  async loadGrievanceHistoryById(data: any) {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadGrievanceHistory, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //reply grievance
  async replyGrievance(data: any) {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.replyFromInternalUser, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //load status
  async loadStatus() {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadStatus, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  // download attachment
  async downloadAttachment(ghDocument) {
    const data = {
      'documentPath': ghDocument
    }
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.downloadFileForGrievance, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //


    //master grievance view
    async loadMasterGrievanceHistory(data: any) {
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.loadMasterGrievanceHistory, data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }
}
